<template>
	<div>
		<!-- 联系方式 -->
		<div class="infos">
			<div class="row">
				<div class="col-xs-12 col-md-1"></div>
				<div class="col-xs-12 col-md_10 wrap">
					<div class="nav_list">
						<div class="list first">
							<div class="left">
								<img class="pic img-responsive" src="@/assets/img/logo.png" />
							</div>
							<div class="pic">
								<img class="pic img-responsive" :src="zidiyiData" />
							</div>
						</div>

						<div class="list">
							<div class="text-uppercase title">北京 bei jing</div>
							<p><img class="icom_f img-responsive" src="@/assets/img/m.png" /> E
								-mail：jx@jiaxinhaitan.com
							</p>
							<p><img class="icom_f img-responsive" src="@/assets/img/p.png" />
								电&nbsp;&nbsp;&nbsp;&nbsp;话：（北京）010 - 8567
								9789</p>

							<p><img class="icom_f img-responsive" src="@/assets/img/f.png" />
								传&nbsp;&nbsp;&nbsp;&nbsp;真：010-8567 9779</p>
							<p><img class="icom_f img-responsive" src="@/assets/img/l.png" />
								地&nbsp;&nbsp;&nbsp;&nbsp;址：北京市朝阳区华熙国际中心C座36层</p>
						</div>

						<div class="list">
							<div class="text-uppercase title">福建 fu jian</div>
							<p><img class="icom_f img-responsive" src="@/assets/img/m.png" /> E
								-mail：jx@jiaxinhaitan.com
							</p>
							<p><img class="icom_f img-responsive" src="@/assets/img/p.png" />
								电&nbsp;&nbsp;&nbsp;&nbsp;话：（福建）0591-8759
								5910</p>
							<p><img class="icom_f img-responsive" src="@/assets/img/f.png" />
								传&nbsp;&nbsp;&nbsp;&nbsp;真：0591-8759 5922</p>
							<p><img class="icom_f img-responsive" src="@/assets/img/l.png" />
								地&nbsp;&nbsp;&nbsp;&nbsp;址：福建省福州市晋安区华林路257号福侨大厦12F</p>
						</div>

						<div class="list">
							<div class="text-uppercase title">OA系统入口 OA System</div>
							<p><img class="icom_f img-responsive pointers" src="@/assets/img/f.png" /> OA系统：<a
									href="http://oa.jiaxinhaitan.com:8090" target="_blank">点击前往OA系统</a>


							</p>

						</div>

					</div>
				</div>
				<div class="col-xs-12 col-md-1"></div>
			</div>
		</div>

		<div class="slider hidden-xs">


			<div class="slider_center commo_slider_div">
				<img class="gz_img" src="@/assets/img/news/公众号.png" />

				<div class="center_imgs">
					<div class="imgs1 css3" v-for="item in companyList">
						<div class="bor"></div>
						<img class="fu_img" :src="item.image" @click="goShop1(item,item)" />
						<div class="posi_img css3">
							<div class="tit line-1">{{lang=='CN' ? item.cn_name:item.en_name }}</div>
							<img class="wxImg" :src="item.ewm2" />
							<div class="txt line-1">{{lang=='CN' ? '微信扫一扫关注公众号':'Scan your wechat account' }}</div>
						</div>
					</div>

				</div>
			</div>

			<div class="slider_center commo_slider_div">
				<img class="" src="@/assets/img/news/品牌商城.png" />

				<div class="center_imgs">
					<div class="imgs1  css3" v-for="item in companyList">
						<div class="bor"></div>
						<img class="fu_img" :src="item.image" @click="goShop(item.id)" />
						<div class="posi_img css3">
							<div class="tit line-1">{{lang=='CN' ? item.cn_name:item.en_name }}</div>
							<img class="wxImg" :src="item.ewm" />
							<div class="txt line-1">{{lang=='CN' ? '微信扫一扫查看商城':'Scan your wechat account' }}</div>
						</div>
					</div>

				</div>
			</div>

			<div class="slider_down">
				<img class="" src="@/assets/img/news/up.png" />
			</div>
		</div>

		<footer>
			<div class="container container-fluid">
				<div class="row">
					<div class="col-xs-12 col-md-1"></div>
					<div class="col-xs-12 col-md_10 content">
						<p>
							<img src="@/assets/beian.png" alt="" style="position: relative;top: -3px;">
							<a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35011102350885"
								target="_blank">闽公网安备 {{siteData.beian}}</a>
						</p>
						<p>工信部备案：<a href="https://beian.miit.gov.cn/" target="_blank">{{siteData.beian}}</a></p>
						<p>版权所有：{{siteData.name}}</p>
					</div>
					<div class="col-xs-12 col-md-1"></div>
				</div>
			</div>
		</footer>


	</div>
</template>

<script>
	export default {
		name: 'Footer',
		data() {
			return {
				siteData: [],
				companyList: [],
				zidiyiData: '',
				lang: localStorage.getItem('lang') || 'CN',
			}
		},

		created(option) {
			this.getSiteData()
			this.getZidiyiData()

		},

		mounted() {
			this.getCompanyList()
			$(".slider_down").click(function() {
				$("html, body").animate({
					scrollTop: $("#app").offset().top
				}, {
					duration: 500,
					easing: "swing"
				});
				return false;
			});
		},


		methods: {

			isPhone() {
				var info = navigator.userAgent;
				//通过正则表达式的test方法判断是否包含“Mobile”字符串
				var isPhone = /mobile/i.test(info);
				//如果包含“Mobile”（是手机设备）则返回true
				return isPhone;
			},
			//获取参数
			getUrlKey: function(name) {
				return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location
					.href) || [, ""])[1].replace(/\+/g, '%20')) || null
			},

			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			// 获取自定义图片 底部二维码
			getZidiyiData() {
				let data = {}
				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {

					this.zidiyiData = res.data.data.qrcode.files
				}).catch(err => {});
			},

			//获取系统信息
			getSiteData() {
				let data = {}
				this.$axios.get("/api/jx/site_list", {
					params: data
				}).then((res) => {
					this.siteData = res.data.data
				}).catch(err => {})
			},

			//获取侧边公司列表
			getCompanyList() {
				let data = {}
				this.$axios.get("/api/jx/cb_company", {
					params: data
				}).then((res) => {
					this.companyList = res.data.data
					// console.log(res.data, 9991);
				}).catch(err => {})
			},
			next_toggle(index, id) {
				this.$emit(`toggleNext`, index, id);
			},
			goShop1(item) {
				let new_http = window.location.origin,
					url = ''
				if (new_http == this.prod) {
					new_http = this.prod + '/web/'
				}
				if (window.location.hostname == 'localhost') {
					new_http = new_http + `/`
				}
				switch (item.cn_name) {
					case "沈绍安漆艺":
						url = new_http + `#/coreplate?parent_id=9&curr=0&jx_index=94`
						window.history.replaceState(null, '', url)
						if (this.$route.path == '/coreplate') {
							this.next_toggle(0, "94")
						} else {
							this.$router.push({
								name: 'Coreplate',
								query: {
									parent_id: 9,
									curr: 0,
									jx_index: 94
								}
							})
						}
						break;
					case "艺品芸":
						url = new_http + `#/coreplate?parent_id=9&curr=0&jx_index=26`
						window.history.replaceState(null, '', url)
						if (this.$route.path == '/coreplate') {
							this.next_toggle(0, "26")
						} else {
							this.$router.push({
								name: 'Coreplate',
								query: {
									parent_id: 9,
									curr: 0,
									jx_index: 26
								}
							})
						}
						break;
					case "大福湾":
						url = new_http + `#/coreplate?parent_id=9&curr=0&jx_index=27`
						window.history.replaceState(null, '', url)
						if (this.$route.path == '/coreplate') {
							this.next_toggle(0, "27")
						} else {
							this.$router.push({
								name: 'Coreplate',
								query: {
									parent_id: 9,
									curr: 0,
									jx_index: 27
								}
							})
						}
						break;
					case "嘉世传媒":
						url = new_http + `#/coreplate?parent_id=9&curr=0&jx_index=22`
						window.history.replaceState(null, '', url)
						if (this.$route.path == '/coreplate') {
							this.next_toggle(0, "22")
						} else {
							this.$router.push({
								name: 'Coreplate',
								query: {
									parent_id: 9,
									curr: 0,
									jx_index: 22
								}
							})
						}
						break;
					case "正佳慈善基金":
						this.$router.push({
							name: 'Dqgy',
							query: {
								parent_id: 12,
								index: 1,
								curr: 1
							}
						})
						break;
					case "海坛控股":
						this.$router.push({
							name: 'Group_overview',
							query: {
								parent_id: 8
							}
						})
						break;
					default:
				}
			},
			goShop(id) {
				this.$router.push({
					path: `shop`,
					query: {
						id: id
					}
				})
			},
		},

	};
</script>

<style lang='scss' scoped>
	.col-md-1 {
		width: 13.333333% !important;
	}

	.col-md_10 {
		width: 73.3333% !important;

	}

	.wrap {
		padding: 0;

		.first {
			margin-left: 0 !important;
		}
	}

	.infos {
		background: #F0F4F5;
		padding: 80px 0px;

		.row {
			margin: 0;
		}

		.nav_list {
			display: flex;
			justify-content: space-between;

			.list {
				flex: 1;
				margin: 0 15px;

				.left {
					.pic {
						width: 150px;
						padding-bottom: 30px;

						.pic {
							width: 150px;
							height: 150px;
						}
					}

					.text-left {
						color: #006170;
						font-size: 24px;
					}

					.text-uppercase {
						color: #006170;
						font-size: 34px;
						position: relative;
					}
				}

				.title {
					height: 72px;
					font-size: 24px;
					position: relative;
					color: #1A1A1A;
					margin: 30px 0 38px 0;
					font-weight: 700;

					&::before {
						content: '';
						width: 150px;
						background: #000000;
						display: block;
						height: 1px;
						position: absolute;
						bottom: 0px;
						left: 0px;
					}
				}

				.icom_f {
					display: inline-block;
					padding-right: 10px;
					width: 26px;
				}

				p {
					font-size: 14px;
				}
			}
		}
	}

	.slider {
		position: fixed;
		z-index: 99;
		right: 50px;
		bottom: 100px;

		.slider_down {
			z-index: 10;
			position: relative;
		}

		.commo_slider_div {
			background: #fff;
			margin-bottom: 5px;

			>img {
				position: relative;
				z-index: 99;
			}

			.center_imgs {
				width: 88px;
				height: 0;
				border-left: 1px solid #d6d7dc;
				border-right: 1px solid #d6d7dc;
			}

			&:hover .center_imgs {
				height: auto;
			}

			.imgs1 {
				background: #ffffff;
				position: relative;
				overflow: hidden;
				height: 0;


				img {
					width: 88px;
					height: 88px;
					object-fit: contain;

				}

				.fu_img {
					position: relative;
					z-index: 2;
				}

				.posi_img {
					width: 0px;
					height: 260px;
					border: 2px solid #006170;
					position: absolute;
					background: #fff;
					right: 0;
					top: -44px;
					opacity: 0;
					z-index: -1;
					text-align: center;
					overflow: hidden;

					.tit {
						line-height: 50px;
						text-align: center;
						font-size: 18px;
						color: #1a1a1a;
					}

					.wxImg {
						width: 150px;
						height: 150px;
						margin: 0 auto;
					}

					.txt {

						text-align: center;
						font-size: 14px;
						color: #1a1a1a;
						margin-top: 17px;
					}
				}

				&:hover {
					overflow: initial;
				}

				&:hover .posi_img {
					width: 206px;
					right: 100px;
					opacity: 1;
				}
			}

			&:hover .imgs1:hover .bor {
				width: 88px;
				height: 88px;
				position: absolute;
				top: -1px;
				left: -1px;
				border: 2px solid #006170;
			}

			&:hover .imgs1 {
				cursor: pointer;
				position: relative;
				height: 88px;
				margin-bottom: 2px;
				border-bottom: 1px solid #d6d7dc;
			}
		}

	}

	footer {
		width: 100%;
		height: 120x;
		background-color: #FFFFFF;
		color: #1A1A1A;

		.container {
			width: 100%;

			.content {
				display: flex;
				justify-content: space-between;
				height: 120px;
				align-items: center;

				p {
					font-size: 14px;

					a {
						color: #1A1A1A;
					}
				}
			}

		}
	}

	.pointers {
		cursor: pointer;
	}

	.pointers:hover {
		color: #006170;
	}
</style>
